import { useEffect, useState } from 'react';
import * as signalR from '@microsoft/signalr';

declare var process: any;
const HUB_URL =
  (process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL.trim().length > 0
    ? process.env.REACT_APP_API_URL.trim()
    : 'https://api.playsos.online/gamehub');
  
// Vite veya CRA için ortam değişkeni kontrolü
let MODE = 'production';
try {
  // Vite
  if (typeof import.meta !== 'undefined' && (import.meta as any).env && (import.meta as any).env.MODE) {
    MODE = (import.meta as any).env.MODE;
  // CRA
  } else if (typeof process !== 'undefined' && (process as any).env && (process as any).env.NODE_ENV) {
    MODE = (process as any).env.NODE_ENV;
  }
} catch (e) {}
const LOG_LEVEL = MODE === 'development' ? signalR.LogLevel.Information : signalR.LogLevel.None;


export const useSignalR = () => {
  const [connection, setConnection] = useState<signalR.HubConnection | null>(null);
  const [isConnected, setIsConnected] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(HUB_URL, {
        withCredentials: true // 🔥 Bunu mutlaka ekle
      })
      .withAutomaticReconnect()
      .configureLogging(LOG_LEVEL)
      .build();

    const startConnection = async () => {
      try {
        await hubConnection.start();
        setConnection(hubConnection);
        setIsConnected(true);
        setError(null);
      } catch (err) {
        setError('Failed to connect to game server');
      }
    };

    // Bağlantı tekrar kurulduğunda connection nesnesini yeniden oluştur
    hubConnection.onreconnected(() => {
      hubConnection = new signalR.HubConnectionBuilder()
        .withUrl(HUB_URL, {
          withCredentials: true
        })
        .withAutomaticReconnect()
        .configureLogging(LOG_LEVEL)
        .build();
      setConnection(hubConnection);
      setIsConnected(true);
    });

    startConnection();

    return () => {
      hubConnection.stop();
    };
  }, []);

  return {
    connection,
    isConnected,
    error
  };
};
